PJQ.views.settings.PlanRoomOrderingSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Planroom-Ordering')
	},
	events: {
		'click .btn-ordering-save': 'saveSettings',
		'click .btn-payment-info': 'changePaymentInfo'
	},
	beforeRender: function () {
		this.renderData = {
			model: this.model
		}
	},
	afterRender: function () {

		if (PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.HIDE_SAVE_PAYMENT_INFO))
			this.$('.btn-payment-info').hide();

		new PJQ.Binder(this.$el, this.model, {
			setDefaultValues: true,
			afterChange: _.bind(function () {
				this.onChange();
			}, this)
		});

		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		});


		new PJQ.inputs.Selectpicker({
			el: this.$('.select-delivery-options'),
			defaultValue: (this.model.get('deliverBy').length > 0) ? this.model.get('deliverBy') : "Next Day (Morning)",
			onChange: _.bind(function (value) {
				this.model.set('deliverBy', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-large-copies'),
			defaultValue: this.model.get('largeFormatCopyCount'),
			onChange: _.bind(function (value) {
				this.model.set('largeFormatCopyCount', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-large-print-size'),
			defaultValue: (this.model.get('largeFormatPrintSize').length > 0) ? this.model.get('largeFormatPrintSize') : "FULL SIZE",
			onChange: _.bind(function (value) {
				this.model.set('largeFormatPrintSize', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-large-paper'),
			defaultValue: (this.model.get('largeFormatPaper').length > 0) ? this.model.get('largeFormatPaper') : "WHITE BOND",
			onChange: _.bind(function (value) {
				this.model.set('largeFormatPaper', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-large-binding'),
			defaultValue: (this.model.get('largeFormatBinding').length > 0) ? this.model.get('largeFormatBinding') : "LOOSE",
			onChange: _.bind(function (value) {
				this.model.set('largeFormatBinding', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-small-copies'),
			defaultValue: this.model.get('smallformatCopyCount'),
			onChange: _.bind(function (value) {
				this.model.set('smallFormatCopyCount', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-small-paper'),
			defaultValue: (this.model.get('smallFormatPaper').length > 0) ? this.model.get('smallFormatPaper') : "WHITE BOND",
			onChange: _.bind(function (value) {
				this.model.set('smallFormatPaper', value);
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-small-binding'),
			defaultValue: (this.model.get('smallFormatBinding').length > 0) ? this.model.get('smallFormatBinding') : "LOOSE",
			onChange: _.bind(function (value) {
				this.model.set('smallFormatBinding', value);
				this.onChange();
			}, this)
		});
	},
	changePaymentInfo: function () {
		new PJQ.views.settings.PaymentInfoModal();
	},
	onChange: function () {
		if (typeof this.options.onChange === 'function') {
			this.options.onChange(this.model);
		}
	},
	cancelEdit: function () {
		this.model.fetch({
			success: _.bind(function () {
				this.render();
			}, this)
		});
		this.render();
	},
	saveSettings: function () {
		if (this.model.hasChanged()) {
			this.model.patch(null, {
				success: _.bind(function () {
					this.render();
					PJQ.notifications.notify.successNotify({
						message: 'Address book settings saved'
					});
				}, this)
			});
		}
	}
});

PJQ.views.settings.PaymentInfoModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Payment-Settings'),
		minWidth: 700
	},
	defaultEvents: {
		'click .btn-save': 'save',
		'click .btn-cancel': 'cancel',
		'keyup .input-card-number': 'setCardBrand',
		'click .btn-edit': 'edit',
		'click .btn-copy-profile': 'copyProfile'
	},
	beforeModalCreated: function () {
		this.user = new PJQ.models.contacts.Contact({
			id: -PJQ.app.session.user.id
		});

		if (!this.user.isFetched) {
			this.user.fetch();
		}

		if (this.model == null) {
			this.model = new PJQ.models.settings.PaymentInfo();
		}

		if (!this.model.isFetched) {
			this.model.fetch({
				success: _.bind(function () {
					this.render();
				}, this)
			});
		}
	},
	renderData: function () {
		return {
			model: this.model,
			today: new Date()
		};
	},
	afterRender: function () {
		this.isEdit = false;
		new PJQ.Binder(this.$el, this.model);

		PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-user-phone'));
		PJQ.helpers.inputHelpers.inputMaskCreditCard(this.$('.input-card-number'));

		this.statePicker = new PJQ.inputs.Selectpicker({
			el: this.$('.user-edit-state'),
			defaultValue: _.size(this.model.get('state')) > 0 ? this.model.get('state').toLowerCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('state', value.toUpperCase());
			}, this)
		});
		this.countryChanged();

		new PJQ.inputs.Selectpicker({
			el: this.$('.user-edit-country'),
			noneSelectedText: 'Select Value',
			defaultValue: _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : null,
			onChange: _.bind(function (value) {
				this.model.set('country', value.toUpperCase());
				this.model.set('zip', '');
				this.model.set('state', '');
				this.countryChanged();
			}, this)
		});

		this.monthPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-expiration-month'),
			noneSelectedText: '',
			onChange: _.bind(function (value) {
				this.model.set('expMonth', value);
			}, this)
		});

		this.yearPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-expiration-year'),
			noneSelectedText: '',
			onChange: _.bind(function (value) {
				this.model.set('expYear', value);
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-expiration-month-disabled'),
			noneSelectedText: '',
			defaultValue: this.model.get('expMonth'),
			onChange: _.bind(function (value) {
				this.model.set('expMonth', value);
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-expiration-year-disabled'),
			noneSelectedText: '',
			defaultValue: this.model.get('expYear'),
			onChange: _.bind(function (value) {
				this.model.set('expYear', value);
			}, this)
		});
		this.setCardBrand();
	},
	copyProfile: function () {
		this.model.set('companyName', this.user.get('companyName'));
		this.model.set('cardholderName', this.user.get('contactName'));
		this.model.set('address1', this.user.get('address1'));
		this.model.set('address2', this.user.get('address2'));
		this.model.set('city', this.user.get('city'));
		this.model.set('zip', this.user.get('zip'));
		this.model.set('state', this.user.get('state'));
		this.model.set('country', this.user.get('country'));
		this.model.set('phone', this.user.get('phone'));
		this.model.set('phoneExt', this.user.get('phoneExtension'));
		this.model.set('email', this.user.get('email'));
		this.render()
	},
	setCardBrand: function () {
		let cardBrand = PJQ.helpers.paymentHelpers.getCardIssuer(this.model.get('cardNumber')),
			icon = PJQ.helpers.paymentHelpers.getCardIssuerIconFAClass(cardBrand);
		this.$('.card-brand').addClass('fs-30 ' + icon);
	},
	countryChanged: function () {
		let country = _.size(this.model.get('country')) > 0 ? this.model.get('country').toLowerCase() : 'us',
			options = '<option value="">Select Value</option>';
		_.each(PJQ.constants.states[country], function (state) {
			options += '<option value="' + state.abbreviation.toLowerCase() + '">' + state.name + '</option>';
		});
		this.statePicker.$el.html(options);
		this.statePicker.refresh();
		if (_.size(this.model.get('state')) > 0)
			this.statePicker.setValue(this.model.get('state').toLowerCase());

		PJQ.helpers.inputHelpers.inputMaskZip(this.$('.user-edit-zip'), country);
	},
	edit: function () {
		this.isEdit = true;
		let $prepend = this.$('.card-type-prepend');
		this.$('.card-hidden').hide();
		this.$('.card-shown').attr('hidden', false);
		this.$('.select-expiration-year').attr('disabled', false);
		this.$('.select-expiration-month').attr('disabled', false);
		$prepend.removeClass();
		$prepend.addClass('card-type-prepend fal fa-question fs-30')
	},
	validate: function () {
		let isValid = true;

		let isCompanyValid = _.size(this.model.get('companyName').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-company-name'), isCompanyValid);
		isValid = isCompanyValid && isValid;

		let emailValid = PJQ.helpers.validators.validateEmail(this.$('.input-user-email').val());
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-email'), (emailValid.success));
		isValid = emailValid.success && isValid;

		let isContactValid = _.size(this.model.get('cardholderName').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-cardholder-name'), isContactValid);
		isValid = isContactValid && isValid;

		let isAddressValid = _.size(this.model.get('address1').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-address-1'), isAddressValid);
		isValid = isAddressValid && isValid;

		let isStateValid = _.size(this.model.get('state').trim()) > 0;
		isValid = isStateValid && isValid;
		this.$('.user-edit-state').removeClass('p-field-error');
		if (!isStateValid) {
			this.$('.user-edit-state').addClass('p-field-error');
		}

		let isCityValid = _.size(this.model.get('city').trim()) > 0;
		PJQ.helpers.inputHelpers.setInputError(this.$('.user-edit-city'), isCityValid);
		isValid = isCityValid && isValid;

		let isZipValid = _.size(this.model.get('zip').trim()) > 4;
		PJQ.helpers.inputHelpers.setInputError(this.$('.user-edit-zip'), isZipValid);
		isValid = isZipValid && isValid;

		let isPhoneValid = _.size(this.model.get('phone')) >= 10;
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-user-phone'), isPhoneValid);
		isValid = isPhoneValid && isValid;

		let isCardValid = PJQ.helpers.paymentHelpers.validateCreditCard(this.model.get('cardNumber'));
		PJQ.helpers.inputHelpers.setInputError(this.$('.input-card-number'), isCardValid);
		isValid = isCardValid && isValid;

		let isYearValid = (this.yearPicker.getValue() != null);
		isValid = isYearValid && isValid;
		this.$('.select-expiration-year').removeClass('p-field-error');
		if (!isYearValid) {
			this.$('.select-expiration-year').addClass('p-field-error');
		}

		let isMonthValid = (this.monthPicker.getValue() != null);
		isValid = isMonthValid && isValid;
		this.$('.select-expiration-month').removeClass('p-field-error');
		if (!isMonthValid) {
			this.$('.select-expiration-month').addClass('p-field-error');
		}

		return isValid;
	},
	save: function () {
		if (this.isEdit) {
			let cardNumber = this.$('.input-card-number').val();
			this.model.set('cardNumber', cardNumber.replace(/\D/g, ''));
		}
		if (this.validate()) {
			this.model.save();
			this.isEdit = false;
			this.removeModal();
		}
	},
	cancel: function () {
		this.isEdit = false;
		this.removeModal();
	}
});
